module.exports = __webpack_public_path__ + "media/components/Hero/static/tick-87444284f076ed53712ccb44bea57c47.svg";